import { useMemo } from 'react';

/**
 * Hook to filter codes by search text
 * 
 * @param {Array} codes - The array of code objects to filter
 * @param {string} searchText - The search text to filter by
 * @returns {Object} - Object containing filtered codes and search-related info
 */
const useFilteredCodes = (codes = [], searchText = '') => {

  // Filter codes based on search text
  const filteredCodes = useMemo(() => {
    if (!searchText || searchText.trim() === '') return codes;
    
    const searchLower = searchText.toLowerCase().trim();
    
    // Filter existing codes
    return codes.filter(code => 
      code.name && code.name.toLowerCase().includes(searchLower)
    );
  }, [codes, searchText]);

  // Check if we have an exact match
  const hasExactMatch = useMemo(() => {
    if (!searchText || searchText.trim() === '') return true;
    
    const searchLower = searchText.toLowerCase().trim();
    return codes.some(code => 
      code.name && code.name.toLowerCase() === searchLower
    );
  }, [codes, searchText]);

  return {
    filteredCodes,
    newCodeName: (searchText && searchText.trim() !== '' && !hasExactMatch) ? searchText : null
  };
};

export default useFilteredCodes;
